import { Component, OnDestroy, OnInit } from '@angular/core';
import { Question, UserInterests, UserResponse } from '../../../models/user-interests';
import { ConfigService } from '../../../services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { Subscription } from 'rxjs';
import { CollectionsFacade } from '../../../state/collections/collections.facade';

@Component({
  selector: 'app-user-interests',
  templateUrl: './user-interests.component.html',
  styleUrls: ['./user-interests.component.scss'],
})
export class UserInterestsComponent implements OnInit, OnDestroy {
  section = 'interests';
  interestsForm: UserInterests;
  question: Question;
  questions: Question[];
  validForm: boolean;
  subscriptions: Subscription[];

  constructor(
    router: Router,
    configService: ConfigService,
    private userService: UserService,
    route: ActivatedRoute,
    private readonly collectionsFacade: CollectionsFacade
  ) {
    if (configService.isHidden(this.section)) {
      router.navigate(['/user/checkouts']);
    }

    this.questions = [];
    this.subscriptions = [];

    this.interestsForm = configService.get().userInterests;

    this.interestsForm.formQuestionDTOList.forEach((q) => {
      const question = Question.fromDTOWithUserResponses(q, route.snapshot.data['userInterests']);
      this.questions.push(question);
      this.subscriptions.push(
        question.changedEvent.subscribe(() => {
          this.onSelected();
        })
      );
    });
  }

  ngOnInit() {}

  onSelected() {
    this.validForm = true;
    for (const q of this.questions) {
      if (!q.completed) {
        this.validForm = false;
        break;
      }
    }
  }

  onSubmit() {
    const responses: UserResponse[] = this.questions.map((q) => ({
      questionId: q.id,
      response: q.finalUserResponses,
    }));
    this.subscriptions.push(this.userService.setUserInterests(responses).subscribe());
    this.collectionsFacade.clearStore();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sbs) => sbs.unsubscribe());
  }
}
